// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__NnLru","boxTitle":"Qualiphy_boxTitle__32VbI","box":"Qualiphy_box__Dtlbt","toggleWrap":"Qualiphy_toggleWrap__217J4"};